import * as Sentry from '@sentry/react';

export class SentryServices {
  private dsn: string;
  private env: string;
  private denyUrls?: RegExp[]; // see https://docs.sentry.io/platforms/javascript/configuration/filtering/

  constructor(dsn: string, env?: string, denyUrls?: RegExp[]) {
    this.dsn = dsn;
    this.env = env || 'production';
    this.denyUrls = denyUrls;
  }

  public init = () =>
    Sentry.init({
      dsn: this.dsn,
      environment: this.env,
      denyUrls: this.denyUrls,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: true }),
        Sentry.extraErrorDataIntegration({ depth: 10 }),
        Sentry.browserProfilingIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      profilesSampleRate: 1.0,
      // Session Replay
      tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/], // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

  


}